import React, { createElement } from 'react';

import { Providers } from '../types';

const wrap = <T extends any[]>(...providers: Providers<T>) => (element: React.ReactNode) => providers.reduceRight((element: React.ReactNode, provider) => {
	let Provider: React.ComponentType<any>, providerProps: object = {};

	if (Array.isArray(provider)) [Provider, providerProps] = provider;
	else Provider = provider!;

	const wrap = createElement(Provider, providerProps, element);

	return wrap;
}, element);

export default wrap;
